// extracted by mini-css-extract-plugin
module.exports = {"root":"Artwork_root__3b85r","isRounded":"Artwork_isRounded__mhZC7","image":"Artwork_image__36nlY"};